<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        {{$t('filters')}}
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('role')}}</label>
          <v-select
            style="text-transform: capitalize"
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="roleFilter"
            :options="roleOptions"
            class="w-100"
            @input="val => $emit('update:roleFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('permitted')}}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="planFilter"
            :options="planOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:planFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('status')}}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:statusFilter', val)"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('state')}}</label>
          <v-select
            :value="stateFilter"
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :options="stateOptions"
            class="w-100"
            style="text-transform: capitalize"
            @input="val => $emit('update:stateFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{$t('city')}}</label>
          <v-select
            :value="cityFilter"
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            class="w-100"
            multiple
            taggable
            :no-drop="true"
            style="text-transform: lowercase"
            @input="val => $emit('update:cityFilter', val)"
          />
        </b-col>

        <!-- <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.age') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="ageFilter"
            :options="ageOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:ageFilter', val)"
          />
        </b-col> -->

      </b-row>
      <b-row class="mt-1">
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Hoiwa PRO</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="subcontractorFilter"
            :options="subcontractorOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:subcontractorFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('residency') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="residencyFilter"
            :options="residencyOptions"
            :clearable="false"
            :reduce="val => val.value"
            @input="val => $emit('update:residencyFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    roleFilter: {
      type: [String, null],
      default: null,
    },
    planFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    stateFilter: {
      type: [String, null],
      default: '',
    },
    cityFilter: {
      type: Array,
      default: () => [],
    },
    ageFilter: {
      type: [String, null],
      default: null,
    },
    subcontractorFilter: {
      type: [String, null],
      default: null,
    },
    residencyFilter: {
      type: [String, null],
      default: null,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    stateOptions: {
      type: Array,
      required: true,
    },
    ageOptions: {
      type: Array,
      required: true,
    },
    subcontractorOptions: {
      type: Array,
      required: true,
    },
    residencyOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-select.scss';
</style>
